import Page from "components/Page";
import { Props } from "./Assets";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const Assets = lazyWithRetry(() => import("./Assets"));

export default (props: Props) => (
  <Page>
    <Assets {...props} />
  </Page>
);
